import React, { useEffect } from 'react';
import { ReactNode, SetStateAction, createContext, useState, Dispatch, useContext } from 'react';
import { AuthUser, getCurrentUser } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

type UserType = AuthUser | null | undefined;

type AuthContextType = {
    user: UserType,
    userId: string,
    setUser: Dispatch<SetStateAction<UserType>>,
};

const AuthContext = createContext<AuthContextType>({user: undefined, setUser: () => {}, userId: ''});

const AuthContextProvider = ({children}: {children: ReactNode}) => {
    const [user, setUser] = useState<UserType>(undefined);
    const [error, setError] = useState<unknown>(null);
    const [customState, setCustomState] = useState<string | null>(null);

    const checkUser = async () => {
        try {
            const cognitoUser = await getCurrentUser();
            setUser(cognitoUser)
        } catch (err) {
            // console.log(err);
            setUser(null);
        }
    }

    useEffect(() => {
        checkUser();
    }, []);

    useEffect(() => {
        const listener = async (data: any) => {
            const { event } = data.payload;
            if (event == 'signedOut') {
                setUser(null);
            };
            if (event == 'signedIn') {
                checkUser();
                // console.log('signIn', event);
            };
        };
        const hubListenerCancel = Hub.listen('auth', listener);
        return () => hubListenerCancel();
    }, []);
    return (
        <AuthContext.Provider value={{user, setUser, userId: user?.userId || ''}}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContextProvider;
export const useAuthContext = () => useContext(AuthContext);